import { TextSmall } from '@/components/Texts';
import React from 'react';

const CooperationWithProcessors = () => {
  return (
    <>
      <TextSmall fontWeight={700}>(7) Cooperation with processors</TextSmall>
      <TextSmall>
        As with any larger company, we also use external domestic and foreign
        service providers (e.g. for the areas of IT, logistics,
        telecommunications, sales and marketing) to process our business
        transactions. They are only active according to our instructions and are
        contractually obligated to comply with the data protection regulations
        according to Art. 28 GDPR.
      </TextSmall>
      <TextSmall>
        If personal data from you is passed on by us to our subsidiaries or is
        passed on to us by our subsidiaries (e.g. for advertising purposes),
        this is done on the basis of existing order processing relationships.
      </TextSmall>
    </>
  );
};

export default CooperationWithProcessors;
